import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { Helmet } from 'react-helmet-async';

// components
import Head from '../../components/UI/Head/Head';
import Price from '../../components/Price/Price';

// style
import style from './game.module.css';

const Games = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = 'hidden'; // Отключаем скролл при загрузке

    const timer = setTimeout(() => {
      setLoading(false);
      document.body.style.overflow = 'visible'; // Возвращаем скролл после загрузки
    }, 300); // 1 секунда для имитации загрузки

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = 'visible'; // На случай размонтирования компонента
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Игры Sparta Kazan — Лазертаг, Пейнтбол, Гидробол и другие</title>
        <meta
          name="description"
          content="Выбирайте популярные сценарии лазертага, пейнтбола и гидробола от Sparta в Казани. Эмоции, драйв и адреналин!"
        />
      </Helmet>
      {loading ? (
        <div className="loaderWrapper">
          <div className="loaderPage"></div>
        </div>
      ) : (
        <main className={style.main}>
          <Head url="/" />
          <Price />
          <ToastContainer />
        </main>
      )}
    </>
  );
};
export default Games;
